import {API_URL} from "./index";

export async function apiStartIaQuizSession() {
    const res = await fetch(`${API_URL}/ia-quiz/questions/session`);
    return res.json();
}

export async function apiAnswerIaQuizQuestion(token, selectedOption) {
    const params = new URLSearchParams({token, selectedOption: String(selectedOption)});
    const res = await fetch(`${API_URL}/ia-quiz/questions/session?${params.toString()}`);
    return {ok: res.ok, data: await res.json()};
}

export async function apiSubmitIaQuizResults(token) {
    const res = await fetch(`${API_URL}/ia-quiz/results`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({token}),
    });
    return {ok: res.ok, data: await res.json()};
}

export async function apiGetIaQuizStatistics() {
    const res = await fetch(`${API_URL}/ia-quiz/statistics`);
    return res.json();
}

export async function apiReportIaQuizQuestion(questionId, reason) {
    const res = await fetch(`${API_URL}/ia-quiz/reports`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({questionId, reason}),
    });
    return res.json();
}
